(() => {
  const setup = () => {
    const original = document.querySelector('.product-form__submit');
    const productForm = original?.closest('form');
    if (!original || !productForm || document.querySelector('.sev-sticky-atc')) return;

    const bar = document.createElement('aside');
    bar.className = 'sev-sticky-atc';
    bar.setAttribute('aria-label', 'Hızlı satın alma');

    const label = document.createElement('span');
    label.className = 'sev-sticky-atc__label';
    label.textContent = document.querySelector('.product__title h1')?.textContent?.trim() || 'Ürün';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button sev-sticky-atc__button';
    button.textContent = original.textContent.trim() || 'Sepete ekle';
    button.disabled = original.disabled;
    button.addEventListener('click', () => original.click());

    bar.append(label, button);
    document.body.appendChild(bar);

    let originalVisible = false;
    const update = () => {
      const shouldShow = window.scrollY > 260 && !originalVisible;
      bar.classList.toggle('is-visible', shouldShow);
      button.disabled = original.disabled;
      button.textContent = original.textContent.trim() || 'Sepete ekle';
    };

    new IntersectionObserver(([entry]) => {
      originalVisible = entry.isIntersecting;
      update();
    }, { threshold: 0.15 }).observe(original);

    new MutationObserver(update).observe(original, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true
    });

    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
